import { batchSelectionRepository } from "@src/core/engine/batchSelection/batchSelectionRepository";
import { DESCRIPTION_KEYS_TO_EXCLUDE } from "@src/routes/projects/$projectId/selections/hooks/useFormattedSuggestions";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useCategoryId } from "../../../hooks/useCategoryId";

export function useOutputColumns() {
  const categoryId = useCategoryId();

  const { data: outputColumns } = useSuspenseQuery({
    queryFn: () => {
      const properties =
        batchSelectionRepository.getProductProperties(categoryId);
      return [
        "articleNumber",
        "pipeResult.size",
        "pipeResult.linearPressureDrop",
        "pipeResult.velocity",
        ...properties.outputProperties.map((prop) => `output.${prop}`),
        ...properties.properties.filter(
          (key) =>
            !!key &&
            // Some descriptions are already included in output and complicated
            // to handle on engine side
            !DESCRIPTION_KEYS_TO_EXCLUDE.includes(key),
        ),
      ];
    },
    queryKey: ["batch", "outputColumns", categoryId],
    staleTime: Infinity,
  });

  return outputColumns;
}
